import { Icon, IconProps } from "@iconify/react";

const IconifyIcon = ({ icon, ...rest }: IconProps) => {
  return <Icon icon={icon} fontSize="1.4rem" {...rest} />;
};

export default IconifyIcon;
